import { defineStore } from 'pinia';
import PipelinesAPI from 'dashboard/api/pipelines';
import StagesAPI from 'dashboard/api/stages';
import LostReasonsAPI from 'dashboard/api/lostReasons';

export const usePipelinesStore = defineStore('pipelines', {
  state: () => ({
    list: [],
    current: null,
    loading: false,
    saving: false,
  }),
  actions: {
    async fetchAll() {
      this.loading = true;
      try {
        const { data } = await PipelinesAPI.get();
        this.list = data;
      } finally {
        this.loading = false;
      }
    },
    async fetchOne(id) {
      const { data } = await PipelinesAPI.show(id);
      this.current = data;
      return data;
    },
    async create(payload) {
      const { data } = await PipelinesAPI.create({ pipeline: payload });
      this.list = [data, ...this.list];
      return data;
    },
    async createFromTemplate(templateKey, name) {
      const { data } = await PipelinesAPI.fromTemplate({
        template_key: templateKey,
        name,
      });
      this.list = [data, ...this.list];
      return data;
    },
    async update(id, payload) {
      const { data } = await PipelinesAPI.update(id, { pipeline: payload });
      this.list = this.list.map(p => (p.id === id ? data : p));
      if (this.current?.id === id) this.current = data;
      return data;
    },
    async destroy(id) {
      await PipelinesAPI.delete(id);
      this.list = this.list.filter(p => p.id !== id);
    },
    async createStage(pipelineId, payload) {
      const { data } = await StagesAPI.create(pipelineId, payload);
      return data;
    },
    async updateStage(pipelineId, id, payload) {
      const { data } = await StagesAPI.update(pipelineId, id, payload);
      return data;
    },
    async destroyStage(pipelineId, id) {
      await StagesAPI.destroy(pipelineId, id);
    },
    async reorderStages(pipelineId, positions) {
      await StagesAPI.reorder(pipelineId, positions);
    },
    async listLostReasons(pipelineId) {
      const { data } = await LostReasonsAPI.index(pipelineId);
      return data;
    },
    async createLostReason(pipelineId, payload) {
      const { data } = await LostReasonsAPI.create(pipelineId, payload);
      return data;
    },
  },
});
